import { FormGroup } from "@angular/forms";

export const Automapper = {

    FGToObject: {
        map: function(formGroup: FormGroup, mapTo: object, defaultKeys: DefaultKeys[] = [], defaultValues: DefaultValues[] = []) {
            Object.keys(formGroup.controls).forEach(control => {
                mapTo[control] = formGroup.controls[control].value;
            });
            defaultKeys.forEach(defK => {
                mapTo[defK.to] = formGroup.controls[defK.from].value;
            });
            defaultValues.forEach(defV => {
                mapTo[defV.key] = defV.value;
            });
        }
    },
    ModelToModel: {
        map: function(fromObj: object, toObj: object, defaultKeys: DefaultKeys[] = [], defaultValues: DefaultValues[] = []) {
            Object.keys(fromObj).forEach(param => {
                toObj[param] = fromObj[param];
            });
            defaultKeys.forEach(defK => {
                toObj[defK.to] = fromObj[defK.from];
            });
            defaultValues.forEach(defV => {
                toObj[defV.key] = defV.value;
            });
        }
    }
}

interface DefaultKeys{ 
    from: string,
    to: string
}

interface DefaultValues{ 
    key: string,
    value: any
}